import { useQuery } from '@tanstack/react-query';
import { MaterialApiClient } from 'api';

export const useMaterial = (id: string) => {
  return useQuery({
    queryKey: ['materials', id],
    queryFn: () => MaterialApiClient.getMaterialById(id),
    enabled: !!id,
  });
};

export const useMaterials = () => {
  return useQuery({
    queryKey: ['materials'],
    queryFn: () => MaterialApiClient.getAllMaterials(),
  });
}; 